import React from 'react';

const About = () => {
  return (
    <div id='about' className='w-full py-16 px-4 bg-[#F08000]'>
        <div className=' max-w-[1240px] mx-auto grid md:grid-cols-3 gap-8'>
          <div className='bg-white w-full shadow-xl flex flex-col p-4 my-4 rounded-lg hover:scale-105 duration-300 hover:bg-black hover:text-white'>
              <h2 className='text-2xl font-bold text-center py-8 border-b'>ဆိုင်ဖွင့်တာကြာပြီလာ</h2>
              <div className='text-center font-medium'>
                  <p className='py-2 mx-8 mt-8'>
                  ကျွန်တော်တို့ရီရှင်းဆိုင်သည်လွန်ခဲ့သောနှစ်ပေါင်း ၁၆နှစ် (၂၀၀၆) ခုနှစ်မှစတင်၍ရှမ်းမြောက်သီပေါမြို့တွင်တည်ရှိခဲ့ရာယနေ့တွင်ခိုင်မာတည်တံသောစီးပွါးရေးလုပ်ငန်းတစ်ခုနေပြီဖြစ်ပါသည်။
                  </p>
              </div>
          </div>

          <div className='w-full shadow-xl bg-gray-100 flex flex-col p-4 md:my-0 my-8 rounded-lg hover:scale-105 duration-300 hover:bg-black hover:text-white'>
              <h2 className='text-2xl font-bold text-center py-8 border-b'>Online ကနေကောဝယ်လို့ရလား</h2>
              <div className='text-center font-medium'>
                  <p className='py-2  mx-8 mt-8'>
                    ရာနှုန်းပြည့်စိတ်ချစွာဝယ်ယူအားပေးနိုင်ပါသည်ခင်ဗျာ။ သီပေါမြို့ဠ်လည်း physically ဆိုင်တည်ရှိသည့်အတွက် အဆင်မပြေမှုတစ်စုံတစ်ရာပေါ်ပေါက်ခဲ့ပါက ဆိုင်သို့လာရောက်ဖြေရှင်းနိုင်ပါသည်။ ကျွန်တော်တို့ရီရှင်းသီပေါဆိုင်မှလူကြီးမင်းအားစိတ်ကျေနပ်မှုရစေရန် ရာနှုန်းပြည့်တာဝန်ယူပါသည်ခင်ဗျာ။
                </p>
                 
              </div>
              
          </div>
          <div className='bg-white w-full shadow-xl flex flex-col p-4 my-4 rounded-lg hover:scale-105 duration-300 hover:bg-black hover:text-white'>
              <h2 className='text-2xl font-bold text-center py-8 border-b'>ဘယ်လိုဝန်ဆောင်မှုတွေရှိလဲ</h2>
              <div className='text-center font-medium'>
                  <p className='py-2 mx-8 mt-8'>
                  စျေးဝယ်သူများအား မိမိတို့အိမ်တွင်းဠ်သာ အဆင်ပြေပြေသက်သောင့်သက်သာနှင့်ယုံကြည်စိတ်ချရသော online စျေးဝယ်ယူမှုပြုလုပ်နိုင်ရန် ရီရှင်းသီပေါမှဝန်ဆောင်မှုပေးနေပြီဖြစ်ပါသည်။ ဒါ့အပြင်Video call ဖြင့်ပစ္စည်းပြပေးခြင်း၊ပစ္စည်းအကြောင်းအသေးစိတ်ရှင်းပြခြင်း ဝန်ဆောင်မှုများလည်းပေးထားပါသည်ခင်ဗျာ။
                  </p>
              </div>
          </div>
      </div>
    </div>
  );
};

export default About;
